export const GET_PLC_SAFETY_TRIGGER_BY_ID = 'GET_PLC_SAFETY_TRIGGER_BY_ID';
export const GET_PLC_SAFETY_TRIGGER_BY_ID_SUCCESS = 'GET_PLC_SAFETY_TRIGGER_BY_ID_SUCCESS';
export const GET_PLC_SAFETY_TRIGGER_BY_ID_ERROR = 'GET_PLC_SAFETY_TRIGGER_BY_ID_ERROR';
